<template>
    <div>
        <!-- 页面固定头部 -->
        <a-anchor :getContainer="getModuleContainer" style="width:100%">
            <!-- 面包屑组件 -->
            <FGBreadHead></FGBreadHead>
        </a-anchor>
        <a-page-header class="fun-panel" title="技术人员注销" :sub-title="subTitle" @back="onBack">
            <template v-slot:extra>
                <a-button :loading="loading || saving" type="primary" @click="onSave(0)">保存</a-button>
                <a-button :loading="loading || saving" type="primary" @click="onSave(1)">提交</a-button>
            </template>
            <a-divider></a-divider>
            <a-layout>
                <a-layout-content>
                    <a-spin :spinning="loading">
                        <a-form ref="form" class="fun-edit-form" :label-col="{ span: 6 }" :wrapper-col="{ span: 18 }">
                            <FGCollapsiblePanel title="技术人员登记">
                                <a-row :gutter="[0, 9]">
                                    <a-col :span="12">
                                        <a-form-item label="注销表编号">
                                            <a-input ref="zxsqbbh" v-model="editData.zxsqbbh" disabled />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="12">
                                        <a-form-item label="注销日期" required>
                                            <a-date-picker ref="zxrq" v-model="editData.zxrq" valueFormat="YYYY-MM-DD" style="width:100%" />
                                        </a-form-item>
                                    </a-col>
                                </a-row>
                                <a-row :gutter="[0, 9]">
                                    <a-col :span="12">
                                        <a-form-item label="姓名" required>
                                            <a-input-search ref="xm" readOnly @search="isShow_xm = true" v-model="editData.xm" />
                                            <FGDataSelect
                                                :isShow.sync="isShow_xm"
                                                selectNo="RY1001"
                                                :condition="selStaticCondition"
                                                @saveselect="saveEvent_xm(arguments, editData)"
                                            ></FGDataSelect>
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="12">
                                        <a-form-item label="性别">
                                            <FGDictSelectCN ref="xb" dictNo="RY100101" v-model="editData.xb" disabled />
                                        </a-form-item>
                                    </a-col>
                                </a-row>
                                <a-row :gutter="[0, 9]">
                                    <a-col :span="12">
                                        <a-form-item label="民族">
                                            <FGDictSelectCN ref="mz" dictNo="RY100102" v-model="editData.mz" disabled />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="12">
                                        <a-form-item label="出生日期">
                                            <a-date-picker ref="csrq" v-model="editData.csrq" valueFormat="YYYY-MM-DD" style="width:100%" disabled />
                                        </a-form-item>
                                    </a-col>
                                </a-row>
                                <a-row :gutter="[0, 9]">
                                    <a-col :span="12">
                                        <a-form-item label="证件类型">
                                            <FGDictSelectCN ref="zjlx" dictNo="RY100104" v-model="editData.zjlx" disabled />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="12">
                                        <a-form-item label="证件号码">
                                            <a-input ref="zjhm" v-model="editData.zjhm" disabled />
                                        </a-form-item>
                                    </a-col>
                                </a-row>
                                <a-row :gutter="[0, 9]">
                                    <a-col :span="12">
                                        <a-form-item label="所属单位编号">
                                            <a-input ref="ssdwbh" v-model="editData.ssdwbh" disabled />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="12">
                                        <a-form-item label="所属单位名称">
                                            <a-input ref="ssdwmc" v-model="editData.ssdwmc" disabled />
                                        </a-form-item>
                                    </a-col>
                                </a-row>
                                <a-row :gutter="[0, 9]">
                                    <a-col :span="12">
                                        <a-form-item label="区域编号">
                                            <a-input ref="qybh" v-model="editData.qybh" disabled />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="12">
                                        <a-form-item label="区域名称">
                                            <a-input ref="qymc" v-model="editData.qymc" disabled />
                                        </a-form-item>
                                    </a-col>
                                </a-row>
                                <a-row :gutter="[0, 9]">
                                    <a-col :span="12">
                                        <a-form-item label="人员类别">
                                            <FGDictSelectCN ref="rylb" dictNo="RY100105" v-model="editData.rylb" disabled />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="12">
                                        <a-form-item label="职务">
                                            <a-input ref="zw" v-model="editData.zw" disabled />
                                        </a-form-item>
                                    </a-col>
                                </a-row>
                                <a-row :gutter="[0, 9]">
                                    <a-col :span="12">
                                        <a-form-item label="职称">
                                            <FGDictSelectCN ref="zc" dictNo="RY100109" v-model="editData.zc" disabled />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="12">
                                        <a-form-item label="职称专业">
                                            <a-input ref="zczy" v-model="editData.zczy" disabled />
                                        </a-form-item>
                                    </a-col>
                                </a-row>
                                <a-row :gutter="[0, 9]">
                                    <a-col :span="12">
                                        <a-form-item label="批准时间">
                                            <a-date-picker ref="pzsj" v-model="editData.pzsj" valueFormat="YYYY-MM-DD" style="width:100%" disabled />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="12">
                                        <a-form-item label="毕业院校">
                                            <a-input ref="byyx" v-model="editData.byyx" disabled />
                                        </a-form-item>
                                    </a-col>
                                </a-row>
                                <a-row :gutter="[0, 9]">
                                    <a-col :span="12">
                                        <a-form-item label="毕业时间">
                                            <a-date-picker ref="bysj" v-model="editData.bysj" valueFormat="YYYY-MM-DD" style="width:100%" disabled />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="12">
                                        <a-form-item label="所学专业">
                                            <a-input ref="sxzy" v-model="editData.sxzy" disabled />
                                        </a-form-item>
                                    </a-col>
                                </a-row>
                                <a-row :gutter="[0, 9]">
                                    <a-col :span="12">
                                        <a-form-item label="学历">
                                            <FGDictSelectCN ref="xl" dictNo="RY100106" v-model="editData.xl" disabled />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="12">
                                        <a-form-item label="学位">
                                            <FGDictSelectCN ref="xw" dictNo="RY100107" v-model="editData.xw" disabled />
                                        </a-form-item>
                                    </a-col>
                                </a-row>
                                <a-row :gutter="[0, 9]">
                                    <a-col :span="12">
                                        <a-form-item label="参加工作时间">
                                            <a-date-picker ref="cjgzsj" v-model="editData.cjgzsj" valueFormat="YYYY-MM-DD" style="width:100%" disabled />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="12">
                                        <a-form-item label="从业时间">
                                            <a-date-picker ref="cysj" v-model="editData.cysj" valueFormat="YYYY-MM-DD" style="width:100%" disabled />
                                        </a-form-item>
                                    </a-col>
                                </a-row>
                                <a-row :gutter="[0, 9]">
                                    <a-col :span="12">
                                        <a-form-item label="固定电话">
                                            <a-input ref="gddh" v-model="editData.gddh" disabled />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="12">
                                        <a-form-item label="移动电话">
                                            <a-input ref="yddh" v-model="editData.yddh" disabled />
                                        </a-form-item>
                                    </a-col>
                                </a-row>
                                <a-row :gutter="[0, 9]">
                                    <a-col :span="12">
                                        <a-form-item label="个人简历">
                                            <a-input ref="grjl" v-model="editData.grjl" disabled />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="12">
                                        <a-form-item label="上岗证编号">
                                            <a-input ref="sgzbh" v-model="editData.sgzbh" />
                                        </a-form-item>
                                    </a-col>
                                </a-row>
                                <a-row :gutter="[0, 9]">
                                    <a-col :span="12">
                                        <a-form-item label="执业资格证书编号">
                                            <a-input ref="zyzgzsbh" v-model="editData.zyzgzsbh" disabled />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="12">
                                        <a-form-item label="登记单位编号">
                                            <a-input ref="zcdwbh" v-model="editData.zcdwbh" disabled />
                                        </a-form-item>
                                    </a-col>
                                </a-row>
                                <a-row :gutter="[0, 9]">
                                    <a-col :span="12">
                                        <a-form-item label="登记单位名称">
                                            <a-input ref="zcdwmc" v-model="editData.zcdwmc" disabled />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="12">
                                        <a-form-item label="登记状态">
                                            <FGDictSelectCN ref="zczt" dictNo="RY100108" v-model="editData.zczt" disabled />
                                        </a-form-item>
                                    </a-col>
                                </a-row>
                                <a-row :gutter="[0, 9]">
                                    <a-col :span="12">
                                        <a-form-item label="登记时间">
                                            <a-date-picker ref="zcsj" v-model="editData.zcsj" valueFormat="YYYY-MM-DD" style="width:100%" disabled />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="12">
                                        <a-form-item label="登记周期(年)">
                                            <a-input-number ref="zczq" v-model="editData.zczq" style="width:100%" disabled />
                                        </a-form-item>
                                    </a-col>
                                </a-row>
                                <a-row :gutter="[0, 9]">
                                    <a-col :span="12">
                                        <a-form-item label="首次登记时间">
                                            <a-date-picker ref="sczcsj" v-model="editData.sczcsj" valueFormat="YYYY-MM-DD" style="width:100%" disabled />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="12">
                                        <a-form-item label="下次登记时间">
                                            <a-date-picker ref="xczcsj" v-model="editData.xczcsj" valueFormat="YYYY-MM-DD" style="width:100%" disabled />
                                        </a-form-item>
                                    </a-col>
                                </a-row>
                                <a-row :gutter="[0, 9]">
                                    <a-col :span="12">
                                        <a-form-item label="登记证(执业专用证)编号">
                                            <a-input ref="zczbh" v-model="editData.zczbh" disabled />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="12">
                                        <a-form-item label="主专业">
                                            <a-input ref="zzy" v-model="editData.zzy" disabled />
                                        </a-form-item>
                                    </a-col>
                                </a-row>
                                <a-row :gutter="[0, 9]">
                                    <a-col :span="12">
                                        <a-form-item label="辅专业">
                                            <a-input ref="fzy" v-model="editData.fzy" disabled />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="12">
                                        <a-form-item label="注销说明" required>
                                            <a-input ref="zxsm" v-model="editData.zxsm" />
                                        </a-form-item>
                                    </a-col>
                                </a-row>
                                <a-row :gutter="[0, 9]">
                                    <a-col :span="12">
                                        <a-form-item label="录入部门">
                                            <a-input ref="lrbmmc" v-model="editData.lrbmmc" disabled />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="12">
                                        <a-form-item label="录入人">
                                            <a-input ref="lrrxm" v-model="editData.lrrxm" disabled />
                                        </a-form-item>
                                    </a-col>
                                </a-row>
                                <a-row :gutter="[0, 9]">
                                    <a-col :span="12">
                                        <a-form-item label="录入时间">
                                            <a-input ref="lrrq" v-model="editData.lrrq" disabled />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="12">
                                        <a-form-item label="备注">
                                            <a-input ref="bz" v-model="editData.bz" />
                                        </a-form-item>
                                    </a-col>
                                </a-row>
                            </FGCollapsiblePanel>
                            <FGCollapsiblePanel title="技术人员培训记录">
                                <vxe-table
                                    ref="itemPXJLTable"
                                    size="mini"
                                    resizable
                                    keep-source
                                    auto-resize
                                    row-id="id"
                                    align="left"
                                    header-align="center"
                                    highlight-hover-row
                                    show-overflow="tooltip"
                                    :data="editItemPXJLData"
                                    :edit-config="{ trigger: 'click', mode: 'row', showStatus: true, showIcon: false }"
                                >
                                    <vxe-table-column type="seq" title="序号" width="70" align="center">
                                        <template v-slot:edit="scope">
                                            <a-input size="small" v-model="scope.row.xh" disabled />
                                        </template>
                                    </vxe-table-column>
                                    <vxe-table-column field="bjmc" title="班级名称" width="150" align="center">
                                        <template v-slot:edit="scope">
                                            <a-input size="small" v-model="scope.row.bjmc" disabled />
                                        </template>
                                    </vxe-table-column>
                                    <vxe-table-column field="bjlb" title="班级类别" width="120" align="center">
                                        <template v-slot:edit="scope">
                                            <a-input size="small" v-model="scope.row.bjlb" disabled />
                                        </template>
                                    </vxe-table-column>
                                    <vxe-table-column field="ksrq" title="报名开始日期" width="150" align="center">
                                        <template v-slot:edit="scope">
                                            <a-input size="small" v-model="scope.row.ksrq" disabled />
                                        </template>
                                    </vxe-table-column>
                                    <vxe-table-column field="jsrq" title="报名结束日期" width="150" align="center">
                                        <template v-slot:edit="scope">
                                            <a-input size="small" v-model="scope.row.jsrq" disabled />
                                        </template>
                                    </vxe-table-column>
                                    <vxe-table-column field="pxksrq" title="培训开始日期" width="150" align="center">
                                        <template v-slot:edit="scope">
                                            <a-input size="small" v-model="scope.row.ksrq" disabled />
                                        </template>
                                    </vxe-table-column>
                                    <vxe-table-column field="pxjsrq" title="培训结束日期" width="150" align="center">
                                        <template v-slot:edit="scope">
                                            <a-input size="small" v-model="scope.row.jsrq" disabled />
                                        </template>
                                    </vxe-table-column>
                                    <vxe-table-column field="pxnr" title="培训内容" width="150" align="center">
                                        <template v-slot:edit="scope">
                                            <a-input size="small" v-model="scope.row.pxnr" disabled />
                                        </template>
                                    </vxe-table-column>
                                    <vxe-table-column field="pxdd" title="培训地点" width="150" align="center">
                                        <template v-slot:edit="scope">
                                            <a-input size="small" v-model="scope.row.pxdd" disabled />
                                        </template>
                                    </vxe-table-column>
                                    <vxe-table-column field="xs" title="学时" width="70" align="center">
                                        <template v-slot:edit="scope">
                                            <a-input size="small" v-model="scope.row.xs" disabled />
                                        </template>
                                    </vxe-table-column>
                                    <vxe-table-column field="sfhg" title="是否合格" width="70" align="center">
                                        <template v-slot:edit="scope">
                                            <a-input size="small" v-model="scope.row.sfhg" disabled />
                                        </template>
                                    </vxe-table-column>
                                    <vxe-table-column field="zsbh" title="证书编号" width="200" align="center">
                                        <template v-slot:edit="scope">
                                            <a-input size="small" v-model="scope.row.zsbh" disabled />
                                        </template>
                                    </vxe-table-column>
                                    <vxe-table-column field="bz" title="备注" width="200" align="center">
                                        <template v-slot:edit="scope">
                                            <a-input size="small" v-model="scope.row.bz" disabled />
                                        </template>
                                    </vxe-table-column>
                                </vxe-table>
                            </FGCollapsiblePanel>
                            <FGCollapsiblePanel title="技术人员登记信息">
                                <vxe-table
                                    ref="itemZCXXTable"
                                    size="mini"
                                    resizable
                                    keep-source
                                    auto-resize
                                    row-id="id"
                                    align="left"
                                    header-align="center"
                                    highlight-hover-row
                                    show-overflow="tooltip"
                                    :data="editItemZCXXData"
                                    :edit-config="{ trigger: 'click', mode: 'row', showStatus: true, showIcon: false }"
                                >
                                    <vxe-table-column type="seq" title="序号" width="70" align="center">
                                        <template v-slot:edit="scope">
                                            <a-input size="small" v-model="scope.row.xh" disabled />
                                        </template>
                                    </vxe-table-column>
                                    <vxe-table-column field="zyzgzsbh" title="执业资格证书编号" width="220" align="center">
                                        <template v-slot:edit="scope">
                                            <a-input size="small" v-model="scope.row.zyzgzsbh" disabled />
                                        </template>
                                    </vxe-table-column>
                                    <vxe-table-column field="zcsj" title="登记时间" width="200" align="center">
                                        <template v-slot:edit="scope">
                                            <a-input size="small" v-model="scope.row.zcsj" disabled />
                                        </template>
                                    </vxe-table-column>
                                    <vxe-table-column field="zcdwbh" title="登记单位编号" width="220" align="center">
                                        <template v-slot:edit="scope">
                                            <a-input size="small" v-model="scope.row.zcdwbh" disabled />
                                        </template>
                                    </vxe-table-column>
                                    <vxe-table-column field="zcdwmc" title="登记单位名称" width="200" align="center">
                                        <template v-slot:edit="scope">
                                            <a-input size="small" v-model="scope.row.zcdwmc" disabled />
                                        </template>
                                    </vxe-table-column>
                                    <vxe-table-column field="zczbh" title="登记证(执业专用证)编号" width="200" align="center">
                                        <template v-slot:edit="scope">
                                            <a-input size="small" v-model="scope.row.zczbh" disabled />
                                        </template>
                                    </vxe-table-column>
                                    <vxe-table-column field="zzy" title="主专业" width="200" align="center">
                                        <template v-slot:edit="scope">
                                            <a-input size="small" v-model="scope.row.zzy" disabled />
                                        </template>
                                    </vxe-table-column>
                                    <vxe-table-column field="fzy" title="辅专业" width="200" align="center">
                                        <template v-slot:edit="scope">
                                            <a-input size="small" v-model="scope.row.fzy" disabled />
                                        </template>
                                    </vxe-table-column>
                                    <vxe-table-column field="bz" title="备注" width="230" align="center">
                                        <template v-slot:edit="scope">
                                            <a-input size="small" v-model="scope.row.bz" disabled />
                                        </template>
                                    </vxe-table-column>
                                </vxe-table>
                            </FGCollapsiblePanel>
                        </a-form>
                    </a-spin>
                </a-layout-content>
                <a-layout-sider class="region-attach-uploadpanel">
                    <AttachUpload :isnew="editData.isnew" :attachCfg.sync="attachCfg" />
                </a-layout-sider>
            </a-layout>
        </a-page-header>
    </div>
</template>
<script>
import { createNamespacedHelpers } from "vuex";
const { mapGetters: userMapGetters } = createNamespacedHelpers("user");
export default {
    name: "JsryzxwhEdit",
    props: ["showEdit", "dataId"],
    data() {
        return {
            // 避免重复点击提交
            saving: false,
            // 主表数据
            editData: {},
            editDataLoading: false,
            // 培训记录明细数据
            editItemPXJLData: [],
            editItemPXJLDataLoading: false,
            // 登记信息明细数据
            editItemZCXXData: [],
            editItemZCXXDataLoading: false,
            selStaticCondition: "",
            isShow_xm: false
        };
    },
    computed: {
        ...userMapGetters(["getUserInfo", "getToken"]),
        subTitle() {
            return this.dataId ? "编辑" : "新增";
        },
        // 是否显示编辑界面
        editIsVisible: {
            get() {
                return this.showEdit;
            },
            set(newVal) {
                this.$emit("update:showEdit", newVal);
            }
        },
        // 当前编辑记录id
        editDataId: {
            get() {
                return this.dataId;
            },
            set(newVal) {
                this.$emit("update:dataId", newVal);
            }
        },
        loading() {
            return this.editDataLoading || this.editItemPXJLDataLoading || this.editItemZCXXDataLoading;
        },
        //附件参数
        attachCfg() {
            return {
                visible: false,
                fktable: "RY_ZXSQB",
                fkfield: "ID",
                fkvalue: this.editData.id,
                attachsource: "RY4000"
            };
        }
    },
    activated() {
        if (!this.editDataId) {
            // 新增，设置默认值
            this.editData = {
                id: this.$FG_util.uuid(),
                isnew: true,
                zxsqbbh: "",
                zxrq: this.$FG_util.formatDate(new Date(), "YYYY-MM-DD"),
                djlxid: "ZXSQB",
                bmid: this.getUserInfo.org_id,
                ryid: this.getUserInfo.personnel_id,
                yhid: this.getUserInfo.id,
                lrbmmc: this.getUserInfo.org_name,
                lrrxm: this.getUserInfo.personnel_name,
                lrrq: this.$FG_util.formatDate(new Date(), "YYYY-MM-DD HH:mm:ss"),
                djzt: "制定"
            };
            this.tableData = [];
            this.submitShow = false;
            this.$FG_helper.handleNewBillCode("ZXSQBBH").then((val) => {
                this.editData.zxsqbbh = val;
            });
        } else {
            this.submitShow = true;
            // 修改，加载数据
            this.loadData();
        }
        // 设置光标位置
        this.$nextTick(() => {
            this.$refs.xm.focus();
        });
    },
    mounted() {
        this.selStaticCondition = " AND SSDWID = '" + this.getUserInfo.companyInfo.id + "'";
    },
    methods: {
        saveEvent_xm(val, currentrow) {
            if (val && val.length > 0) {
                this.editData.jsryid = val[0][0].ID;
                this.editData.xm = val[0][0].XM;
                this.editData.xb = val[0][0].XB;
                this.editData.mz = val[0][0].MZ;
                this.editData.csrq = val[0][0].CSRQ;
                this.editData.zjlx = val[0][0].ZJLX;
                this.editData.zjhm = val[0][0].ZJHM;
                this.editData.ssdwid = val[0][0].SSDWID;
                this.editData.ssdwbh = val[0][0].SSDWBH;
                this.editData.ssdwmc = val[0][0].SSDWMC;
                this.editData.qyid = val[0][0].QYID;
                this.editData.qybh = val[0][0].QYBH;
                this.editData.qymc = val[0][0].QYMC;
                this.editData.rylb = val[0][0].RYLB;
                this.editData.zw = val[0][0].ZW;
                this.editData.zc = val[0][0].ZC;
                this.editData.zczy = val[0][0].ZCZY;
                this.editData.zyzgzsbh = val[0][0].ZYZGZSBH;
                this.editData.zcdwid = val[0][0].ZCDWID;
                this.editData.zcdwbh = val[0][0].ZCDWBH;
                this.editData.zcdwmc = val[0][0].ZCDWMC;
                this.editData.pzsj = val[0][0].PZSJ;
                this.editData.byyx = val[0][0].BYYX;
                this.editData.bysj = val[0][0].BYSJ;
                this.editData.sxzy = val[0][0].SXZY;
                this.editData.zczq = val[0][0].ZCZQ;
                this.editData.zczt = val[0][0].ZCZT;
                this.editData.zczbh = val[0][0].ZCZBH;
                this.editData.sczcsj = val[0][0].SCZCSJ;
                this.editData.xczcsj = val[0][0].XCZCSJ;
                this.editData.zzy = val[0][0].ZZY;
                this.editData.fzy = val[0][0].FZY;
                this.editData.xl = val[0][0].XL;
                this.editData.xw = val[0][0].XW;
                this.editData.cjgzsj = val[0][0].CJGZSJ;
                this.editData.cysj = val[0][0].CYSJ;
                this.editData.gddh = val[0][0].GDDH;
                this.editData.yddh = val[0][0].YDDH;
                this.editData.grjl = val[0][0].GRJL;
                this.editData.sczcsj = val[0][0].SCZCSJ;
                this.editData.sgzbh = val[0][0].SGZBH;
                this.editData.zcsj = val[0][0].ZCSJ;
            }
        },
        onChange(e) {
            let d1 = new Date(e).setFullYear(new Date(e).getFullYear() + 1);
            this.editData.xczcsj = this.$FG_util.formatDate(d1, "YYYY-MM-DD");
        },
        // 根据id查询需要编辑的数据
        loadData() {
            this.editData = {};
            this.editDataLoading = true;
            this.$FG_http
                .post(
                    "./api/main/jsry/jsryzx/selectById",
                    {
                        id: this.editDataId
                    },
                    {
                        showSuccess: false
                    }
                )
                .then(({ success, data, errMsg }) => {
                    this.editDataLoading = false;
                    if (success) {
                        if (data.data) {
                            // 设置当前编辑数据
                            this.editData = data.data;
                        } else {
                            // 加载的数据不存在则提示错误并关闭编辑窗口
                            this.$FG_message.error("P0002").then(() => (this.editIsVisible = false));
                        }
                    } else {
                        // 加载数据出错或没有加载到数据则关闭弹窗
                        this.editIsVisible = false;
                    }
                    // 加载明细数据
                    this.loadItemPXJLData();
                    this.loadItemZCXXData();
                });
        },
        // 加载明细表数据
        loadItemPXJLData() {
            this.editItemPXJLData = [];
            this.editItemPXJLDataLoading = true;
            this.$FG_http
                .post(
                    "./api/main/jsry/jsryzx/listPXJL",
                    {
                        jsryid: this.editData.jsryid,
                        sort: {
                            field: "xh",
                            order: "asc"
                        }
                    },
                    {
                        showSuccess: false
                    }
                )
                .then(({ success, data, errMsg }) => {
                    this.editItemPXJLDataLoading = false;
                    if (success) {
                        this.editItemPXJLData = data.data;
                    } else {
                        // 加载数据出错则返回列表
                        this.editIsVisible = false;
                    }
                });
        },
        // 加载技术人员登记信息列表数据
        loadItemZCXXData() {
            this.editItemZCXXData = [];
            this.editItemZCXXDataLoading = true;
            this.$FG_http
                .post(
                    "./api/main/jsry/jsryzx/listZCXX",
                    {
                        jsryid: this.editData.jsryid,
                        sort: {
                            field: "xh",
                            order: "asc"
                        }
                    },
                    {
                        showSuccess: false
                    }
                )
                .then(({ success, data, errMsg }) => {
                    this.editItemZCXXDataLoading = false;
                    if (success) {
                        this.editItemZCXXData = data.data;
                    } else {
                        // 加载数据出错则返回列表
                        this.editIsVisible = false;
                    }
                });
        },
        //提交form
        onSave(btnType) {
            // 表单校验
            if (btnType === 1) {
                if (!this.editData.zxrq) {
                    this.$FG_message.error("P0001", "注销日期").then(() => this.$refs.zxrq.focus());
                    return;
                }
                if (!this.editData.xm) {
                    this.$FG_message.error("P0001", "姓名").then(() => this.$refs.xm.focus());
                    return;
                }
                if (!this.editData.zxsm) {
                    this.$FG_message.error("P0001", "注销说明").then(() => this.$refs.zxsm.focus());
                    return;
                }
            }
            // 保存操作

            this.saving = true;
            this.$FG_http
                .post(
                    "./api/main/jsry/jsryzx/save",
                    {
                        data: this.editData
                    },
                    {
                        showSuccess: btnType === 1 ? false : true
                    }
                )
                .then(({ success, data, errMsg }) => {
                    this.saving = false;
                    if (success) {
                        // 设置当前行
                        this.editDataId = this.editData.id;
                        this.editData.isnew = false;
                        if (btnType === 1) {
                            this.submit();
                        }
                    } else {
                        this.$refs.bgsqbbh.focus();
                    }
                });
        },
        //提交
        submit(type) {
            this.$FG_message.confirm("P0000", "提交").then((type) => {
                if (type === "ok") {
                    this.$FG_http
                        .post("./api/main/jsry/jsryzx/submit", {
                            id: this.editData.id
                        })
                        .then(({ success, data, errMsg }) => {
                            this.tableDataLoading = false;
                            if (success) {
                                // 设置当前行
                                this.editDataId = this.editData.id;
                                // 返回列表
                                this.onBack();
                            } else {
                                this.$refs.bgsqbbh.focus();
                            }
                        });
                }
            });
        },
        // 返回列表
        onBack() {
            this.editIsVisible = false;
        }
    }
};
</script>
